﻿import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    NgZone,
    ViewChild, ElementRef
} from '@angular/core';
import {CaptchaService} from "./captcha.service";

@Component({
    selector: 'jax-captcha',
    template: '<div  #target class="g-recaptcha"></div> ',
    providers: [CaptchaService]
})
export class CaptchaComponent implements OnInit {

    site_key: string = '6Ld_eBIUAAAAAOY9weg_kXlkmHQFWfHtEh3fReGb';
    theme = 'light';
    type = 'image';
    size = 'normal';
    tabindex = 0;
    language: string = null;

    @Output()
    captchaResponse = new EventEmitter<string>();
    @Output()
    captchaExpired = new EventEmitter();

    @ViewChild('target')
    targetRef: ElementRef;
    widgetId: any = null;

    constructor(
        private _zone: NgZone,
        private _captchaService: CaptchaService) {
    }

    ngOnInit() {
        this._captchaService.getReady(this.language)
            .subscribe((ready) => {
                if (!ready)
                    return;
                this.widgetId = (<any>window).grecaptcha.render(this.targetRef.nativeElement,
                    {
                        'sitekey': this.site_key,
                        'theme': this.theme,
                        'type': this.type,
                        'size': this.size,
                        'tabindex': this.tabindex,
                        'callback': <any>((response: any) => this._zone.run(this.recaptchaCallback.bind(this, response))),
                        'expired-callback': <any>(() => this._zone.run(this.recaptchaExpiredCallback.bind(this)))
                    });
            });
    }

    public reset() {
        if (this.widgetId === null)
            return;
        (<any>window).grecaptcha.reset(this.widgetId);
    }

    public getResponse(): String {
        if (this.widgetId === null)
            return null;
        return (<any>window).grecaptcha.getResponse(this.widgetId);
    }

    private recaptchaCallback(response: string) {
        this.captchaResponse.emit(response);
    }

    private recaptchaExpiredCallback() {
        this.captchaResponse.emit(null);
        this.reset();
    }
}